import Blue from "~/core";

new Blue({
    name: "alert cookie",
    selector: ".alerts--cookie",
    setup(cookies) {
		// This is distinct from the regular cookies js pending the end of a survey program
        const closeBtn = cookies.querySelector(".js-alert-close");
        const ctaLink = cookies.querySelector(".alert__link");
        
        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return false;
        }

        if (!getCookie("GDPR")) {
            setTimeout(() => {
                cookies.classList.add("cookies--active");
                closeBtn.setAttribute("tabindex", 0);
                ctaLink.setAttribute("tabindex", 0);
            }, 1200);
        }

        const acceptCookies = (e) => {
            e.preventDefault();
            
            const form = document.querySelector('form[action="/trackingconsent/accept"]');
            const token = document.querySelector('input[name="__RequestVerificationToken"]').value;

            fetch(form.action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'RequestVerificationToken': token
                },
            })
            .then(response => {
                if (response.ok) {
                    console.log("Success");
                    cookies.classList.remove("cookies--active");
                }
            })
            .catch(error => console.error('An error occurred:', error));
        };

        this.$addEvents(closeBtn, "click enter", acceptCookies);
    }
});